if (!customElements.get("m-video-testimonial")) {
  class MVideoTestimonial extends HTMLElement {
    constructor() {
      super();
    }

    
    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 4,
          slidesPerGroup: 1,
          centeredSlides: true,
          loop: false,
          slideToClickedSlide: false,
          spaceBetween: 20,
            // Navigation arrows
          // navigation: {
          //   nextEl: '.swiper-button-next',
          //   prevEl: '.swiper-button-prev',
          // },
          breakpoints: {
            0: {
              slidesPerView: 1.5,
              spaceBetween: 0,
              centeredSlides: true,
              loop: false,
            },
            768: {
              slidesPerView: 3.5,
              spaceBetween: 0,
              centeredSlides: true,
              loop: true,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 20,
              centeredSlides: false,
            },
          },
            
          
        });
      }
    }
  }

  customElements.define("m-video-testimonial", MVideoTestimonial);
}


if (!customElements.get("m-iwt-column")) {
  class MIwtColumn extends HTMLElement {
    constructor() {
      super();
    }

    
    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 1,
          spaceBetween: 30,
          loop: true,
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          // autoplay: {
          //           delay: 2000,
          //           disableOnInteraction: false
          //       },
            
          
        });
      }
    }
  }

  customElements.define("m-iwt-column", MIwtColumn);
}
